import { createSelector } from "@reduxjs/toolkit";
import { AppState } from "../store";

const selectDrawerOpen = (s: AppState) => s.appStatusState.drawerOpen;
export const drawerOpenSelector = createSelector([selectDrawerOpen], (m) => m);
